import pendenciesService from '@/api/pendencies'
import uploadFileUtils from '@/utils/file-upload-utils'

import {
  PENDENCIES_SET,
  PENDENCIES_SET_LOADING_STATUS,
  PENDENCIES_INCREASE_OFFSET,
  PENDENCIES_CLEAR_ALL,
  PENDENCIES_SET_FILTER,
  PENDENCIES_TOTAL_QUANTITY,
  PENDENCIES_TOTAL_SET_LOADING_STATUS,
  PENDENCIES_SET_UPLOAD_STATUS,
  PENDENCIES_SET_REPLY_STATUS,
  PENDENCIES_SET_FILE,
  PENDENCIES_SET_FILES,
  PENDENCIES_SET_FILES_STATUS,
  PENDENCIES_INCREASE_UPLOAD_REQUESTS,
  PENDENCIES_RESET_UPLOAD_REQUESTS,
  PENDENCIES_SET_TEXT,
  PENDENCIES_DOWNLOADING_STATUS,
  PENDENCIES_SET_TOTAL_PENDENTE,
  PENDENCIES_SET_TOTAL_REALIZADO,
  PENDENCIES_SET_CURRENT_TAB
} from '../types'
import strings from '@/strings'
import notify from '@/api/notification'
import { getCookie } from '../../utils/auth-utils'
import analytics from '@/api/analytics'
import Moment from 'moment'
import { PENDENCIES_PERIOD_DAYS_DEFAULT } from '../../enums'

const state = {
  pendencies: [],
  pendenciesLoadingStatus: 'STATUS_INITIAL',
  offset: 0,
  totalPendencies: 0,
  totalPendenciesLoadingStatus: 'STATUS_INITIAL',
  startDate: null,
  endDate: null,
  status: ['P'],
  typeOfSearch: null,
  q: undefined,
  orderBy: null,
  uploadStatus: 'STATUS_INITIAL',
  replyStatus: 'STATUS_INITIAL',
  downloadStatus: false,
  uploadRequests: 0,
  totalPendente: 0,
  totalRealizado: 0,
  currentTab: 1,
  today: new Date(),
  forceUpdatedInfiniteLoading: new Date()
}

const mutations = {
  [PENDENCIES_SET_TEXT](state, { index, text }) {
    state.pendencies[index].resolution = text
  },
  [PENDENCIES_SET](state, pendencies) {
    state.pendencies = state.pendencies.concat(pendencies)
  },
  [PENDENCIES_SET_LOADING_STATUS](state, status) {
    state.pendenciesLoadingStatus = status
  },
  [PENDENCIES_INCREASE_OFFSET](state) {
    state.offset++
  },
  [PENDENCIES_INCREASE_UPLOAD_REQUESTS](state) {
    state.uploadRequests++
  },
  [PENDENCIES_RESET_UPLOAD_REQUESTS](state) {
    state.uploadRequests = 0
  },
  [PENDENCIES_CLEAR_ALL](state) {
    state.offset = 0
    state.pendencies = []
    state.totalPendencies = 0
  },
  [PENDENCIES_SET_FILTER](state, query) {
    if (!Array.isArray(query.status)) {
      query.status = [query.status]
    }
    state.pendencies = []
    state.offset = 0
    state.startDate = query.startDate
    state.endDate = query.endDate
    state.status = query.status
    state.typeOfSearch = query.typeOfSearch
    state.q = query.q
    state.orderBy = query.orderBy
  },
  [PENDENCIES_TOTAL_QUANTITY](state, totalPendencies) {
    state.totalPendencies = totalPendencies
  },
  [PENDENCIES_TOTAL_SET_LOADING_STATUS](state, status) {
    state.totalPendenciesLoadingStatus = status
  },
  [PENDENCIES_SET_UPLOAD_STATUS](state, status) {
    state.uploadStatus = status
  },
  [PENDENCIES_SET_REPLY_STATUS](state, status) {
    state.replyStatus = status
  },
  [PENDENCIES_DOWNLOADING_STATUS](state, status) {
    state.downloadStatus = status
  },
  [PENDENCIES_SET_FILES](state, { files, pendencyId }) {
    const index = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(pendencyId)
    state.pendencies[index].files = files
  },
  [PENDENCIES_SET_FILE](state, { file, pendencyId }) {
    const pendencyIndex = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(pendencyId)
    let files = state.pendencies[pendencyIndex].files
    const fileIndex = files
      .map(function (e) {
        return e.id
      })
      .indexOf(file.id)
    file.error = false
    if (fileIndex !== -1) {
      state.pendencies[pendencyIndex].files[fileIndex] = file
    } else {
      state.pendencies[pendencyIndex].files.push(file)
    }
  },
  [PENDENCIES_SET_FILES_STATUS](state, fileData) {
    const pendencyIndex = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(fileData.pendencyId)
    const index = state.pendencies[pendencyIndex].files
      .map(function (e) {
        return e.id
      })
      .indexOf(fileData.id)
    if (fileData.status === false) {
      state.pendencies[pendencyIndex].files[index].error = true
      state.pendencies[pendencyIndex].files[index].tryAgainError = true
    } else {
      state.pendencies[pendencyIndex].files[index].id_file = fileData.file.id_file
      state.pendencies[pendencyIndex].files[index].uuid = fileData.file.uuid
      state.pendencies[pendencyIndex].files[index].success = fileData.status
      state.pendencies[pendencyIndex].files[index].error = false
    }
  },
  [PENDENCIES_SET_TOTAL_PENDENTE](state, total) {
    state.totalPendente = total
  },
  [PENDENCIES_SET_TOTAL_REALIZADO](state, total) {
    state.totalRealizado = total
  },
  [PENDENCIES_SET_CURRENT_TAB](state, tabIndex) {
    state.currentTab = tabIndex
  },
  RESET_STORE(state) {
    Object.assign(state, {
      pendencies: [],
      pendenciesLoadingStatus: 'STATUS_INITIAL',
      offset: 0,
      totalPendencies: 0,
      totalPendenciesLoadingStatus: 'STATUS_INITIAL',
      startDate: null,
      endDate: null,
      status: ['P'],
      typeOfSearch: null,
      q: undefined,
      orderBy: null,
      uploadStatus: 'STATUS_INITIAL',
      replyStatus: 'STATUS_INITIAL',
      downloadStatus: false,
      uploadRequests: 0,
      totalPendente: 0,
      totalRealizado: 0,
      currentTab: 1,
      today: new Date(),
      pendenciesSubmitLoadingStatus: false
    })
  },
  PENDENCIES_INCREASE_FORCE_UPDATED_INFINITE_LOADING(state) {
    state.forceUpdatedInfiniteLoading = +new Date()
  }
}

const getters = {
  uploadLimit: () => 3,
  pendencies: state => {
    return state.pendencies
  },
  pendenciesLoadingStatus: state => {
    return state.pendenciesLoadingStatus
  },
  isPendenciesLoading: state => {
    return state.pendenciesLoadingStatus === 'STATUS_LOADING'
  },
  isTotalPendenciesLoading: state => {
    return state.totalPendenciesLoadingStatus === 'STATUS_LOADING'
  },
  hasPendencies: state => {
    return state.pendencies && state.pendencies.length > 0
  },
  totalPendenciesQuantity: state => {
    return state.totalPendencies
  },
  pendencyUploadStatus: state => {
    return state.uploadStatus
  },
  pendencyReplyStatus: state => {
    return state.replyStatus
  },
  pendenciesParams: state => ({
    startDate: state.startDate,
    endDate: state.endDate,
    status: state.status,
    typeOfSearch: state.typeOfSearch,
    q: state.q,
    orderBy: state.orderBy,
    offset: state.offset
  }),
  totalPendenciesRealizado: state => state.totalRealizado,
  totalPendenciesPendente: state => state.totalPendente,
  pendenciesCurrentTab: state => state.currentTab,
  pendencyDefaultStartDate: state => Moment(state.today).subtract(PENDENCIES_PERIOD_DAYS_DEFAULT, 'days').toDate(),
  pendencyDefaultEndDate: state => Moment(state.today).toDate(),
  pendenciesForceUpdatedInfiniteLoading: state => state.forceUpdatedInfiniteLoading
}

const actions = {
  async fetchPendencies({ commit, state, rootState }, { reset = false } = {}) {
    if (reset) {
      commit(PENDENCIES_CLEAR_ALL)
    }

    commit(PENDENCIES_SET_LOADING_STATUS, 'STATUS_LOADING')

    const statusFilter = builderStatusAndStates(state.status)

    try {
      const response = await pendenciesService.getPendencies(
        rootState.authentication.profile.id_laboratory,
        state.offset,
        strings.listsLimits.pendencies,
        state.startDate,
        state.endDate,
        statusFilter,
        state.typeOfSearch,
        state.q,
        state.orderBy
      )

      const pendencies = response.data

      commit(PENDENCIES_SET, pendencies)
      commit(PENDENCIES_INCREASE_OFFSET)

      if (pendencies.length === strings.listsLimits.pendencies) {
        commit(PENDENCIES_SET_LOADING_STATUS, 'STATUS_SUCCESS')
      } else {
        commit(PENDENCIES_SET_LOADING_STATUS, 'STATUS_END')
      }

      if (pendencies.length > 0) {
        analyticsPendenciesIdPerLab(pendencies)
      }
    } catch (error) {
      commit(PENDENCIES_SET_LOADING_STATUS, 'STATUS_FAILED')
    }
  },
  async fetchPendenciesForSubmit({ dispatch, commit }) {
    commit(PENDENCIES_CLEAR_ALL)

    commit('PENDENCIES_INCREASE_FORCE_UPDATED_INFINITE_LOADING')
    await dispatch('getAllTotalPendenciesQuantity')
  },
  async fetchPendenciesForTable({ dispatch }) {
    await dispatch('fetchPendencies')
  },

  saveCurrrentText: ({ commit, state }, { pendencyId, text }) => {
    const index = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(pendencyId)
    commit(PENDENCIES_SET_TEXT, { index, text })
  },
  deletePendencyFile: ({ commit, state }, { fileId, pendencyId }) => {
    const index = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(pendencyId)
    let files = state.pendencies[index].files
    const file = files.find(file => file.id_file === fileId)
    return pendenciesService.deleteDocumentPendency(file.uuid).then(() => {
      files = files.filter(file => file.id_file !== fileId)
      commit(PENDENCIES_SET_FILES, { files, pendencyId })
      submitAnalyticsEventAction('Deletar upload')
    })
  },
  deleteStoreFile: ({ commit, state }, { id, pendencyId }) => {
    const index = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(pendencyId)
    let files = state.pendencies[index].files
    files = files.filter(file => file.id !== id)
    commit(PENDENCIES_SET_FILES, { files, pendencyId })
    commit(PENDENCIES_SET_UPLOAD_STATUS, 'STATUS_INITIAL')
  },
  checkFilesUploaded: ({ commit, state }, id) => {
    const index = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(id)
    let files = state.pendencies[index].files
    let newfiles = []
    for (let i in files) {
      if (files[i].uuid) {
        newfiles.push(files[i])
      }
    }
    commit(PENDENCIES_SET_FILES, { files: newfiles, pendencyId: id })
  },
  clearAllPendenciesData: function ({ commit }) {
    commit(PENDENCIES_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(PENDENCIES_SET_UPLOAD_STATUS, 'STATUS_INITIAL')
    commit(PENDENCIES_SET_REPLY_STATUS, 'STATUS_INITIAL')
    commit(PENDENCIES_CLEAR_ALL)
  },
  setWaitingPendenciesLoadingStatus: function ({ commit }) {
    commit(PENDENCIES_SET_LOADING_STATUS, 'STATUS_WAITING')
  },
  selectPendenciesFilter: function ({ commit }, list) {
    commit(PENDENCIES_SET_FILTER, list)
  },
  getTotalPendenciesQuantity: function ({ commit, state, rootState }) {
    commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_LOADING')
    commit(PENDENCIES_TOTAL_QUANTITY, 0)
    return pendenciesService
      .obtainQuantityPendencies(
        rootState.authentication.profile.id_laboratory,
        state.startDate,
        state.endDate,
        state.status,
        state.typeOfSearch,
        state.q
      )
      .then(response => {
        commit(PENDENCIES_TOTAL_QUANTITY, response.data)
        commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_SUCCESS')
        submitAnalyticsEventTotal(response.data)
      })
      .catch(() => {
        commit(PENDENCIES_TOTAL_QUANTITY, 0)
        commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_FAILED')
      })
  },
  uploadDocumentPendency: function ({ commit, rootState, getters, state }, { file, pendencyId, length }) {
    if (uploadFileUtils.validateFileType(file)) {
      const index = state.pendencies
        .map(function (e) {
          return e.id
        })
        .indexOf(pendencyId)
      let filesLength = state.pendencies[index].files.length
      const cantUpload = !file.error && filesLength >= getters.uploadLimit
      if (cantUpload) {
        if (!file.error) {
          return notify({
            title: 'AVISO:',
            message: 'Limite de 3 arquivos'
          })
        }
      }
      commit(PENDENCIES_SET_UPLOAD_STATUS, 'UPLOAD_STARTED')
      commit(PENDENCIES_SET_FILE, { file, pendencyId })
      const idLab = rootState.authentication.profile.id_laboratory
      let analyticsStartTime = Moment(new Date())
      return pendenciesService
        .uploadDocumentPendency(idLab, file, pendencyId)
        .then(res => {
          commit(PENDENCIES_SET_FILES_STATUS, { id: file.id, status: true, file: res.data, pendencyId })
          commit(PENDENCIES_INCREASE_UPLOAD_REQUESTS)
          if (state.uploadRequests === length) {
            commit(PENDENCIES_SET_UPLOAD_STATUS, 'STATUS_INITIAL')
            commit(PENDENCIES_RESET_UPLOAD_REQUESTS)
          }
          analyticsForUploadTime({ startTime: analyticsStartTime, fileSize: file.size, response: 'Sucesso' })
        })
        .catch(() => {
          commit(PENDENCIES_INCREASE_UPLOAD_REQUESTS)
          commit(PENDENCIES_SET_FILES_STATUS, { id: file.id, status: false, file, pendencyId })
          if (state.uploadRequests === length) {
            commit(PENDENCIES_SET_UPLOAD_STATUS, 'UPLOAD_ERROR')
            commit(PENDENCIES_RESET_UPLOAD_REQUESTS)
          }
          analyticsForUploadTime({ startTime: analyticsStartTime, fileSize: file.size, response: 'Falha' })
        })
    } else {
      return
    }
  },
  replyPendency: function ({ commit }, { pendencyId, resolution }) {
    commit(PENDENCIES_SET_REPLY_STATUS, 'STATUS_LOADING')
    return pendenciesService
      .resolvePendency(pendencyId, resolution)
      .then(() => {
        commit(PENDENCIES_SET_REPLY_STATUS, 'STATUS_SUCCESS')
        notify({
          title: 'AVISO:',
          message: 'Pendência respondida com sucesso'
        })
      })
      .catch(error => {
        commit(PENDENCIES_SET_REPLY_STATUS, 'STATUS_FAILED')
        if (error.response.data.message) {
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
        }
      })
  },
  pendencyDownloadFileUploaded: function ({ commit }, { fileId, pendencyId }) {
    const index = state.pendencies
      .map(function (e) {
        return e.id
      })
      .indexOf(pendencyId)
    let files = state.pendencies[index].files
    const file = files.find(file => file.id_file === fileId)
    return new Promise((resolve, reject) => {
      if (file.uuid) {
        commit(PENDENCIES_DOWNLOADING_STATUS, true)
        pendenciesService
          .downloadDocumentUploaded(file.uuid)
          .then(response => {
            let fileName = file.name
            let fileExtension = fileName.split('.')[1]
            resolve(createFileNewTabLink({ file: response, fileName: fileName, fileExtension: fileExtension }))
            commit(PENDENCIES_DOWNLOADING_STATUS, false)
            submitAnalyticsEventAction('Download de upload')
          })
          .catch(() => {
            resolve(null)
            notify({
              title: 'AVISO:',
              message: 'Erro ao realizar download. Por favor tente novamente.'
            })
            commit(PENDENCIES_DOWNLOADING_STATUS, false)
          })
      } else {
        notify({
          title: 'AVISO:',
          message: 'O download não está disponível no momento. Por favor tente novamente.'
        })
        resolve(null)
      }
    })
  },
  pendencyDownloadTransferedFile: function ({ commit }, { fileId, fileExtension }) {
    return new Promise((resolve, reject) => {
      pendenciesService
        .getTransferedFile(fileId)
        .then(response => {
          let blob
          if (/\.(jpg|jpeg|png|gif)$/i.test(fileExtension)) {
            blob = new Blob([response.data], { type: 'image/' + fileExtension })
          } else {
            blob = new Blob([response.data], { type: 'application/' + fileExtension })
          }

          resolve({ url: URL.createObjectURL(blob) })
        })
        .catch(() => {
          resolve(null)
          notify({
            title: 'AVISO:',
            message: 'Erro ao realizar download. Por favor tente novamente.'
          })
        })
    })
  },
  setUploadStatus: ({ commit }, status) => {
    commit(PENDENCIES_SET_UPLOAD_STATUS, status)
  },
  async getAllTotalPendenciesQuantity({ commit, state, rootState }) {
    commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_LOADING')

    const idLab = rootState.authentication.profile.id_laboratory
    const { startDate, endDate, typeOfSearch, q } = state

    try {
      const [todos, pendente, realizado] = await Promise.all([
        pendenciesService.obtainQuantityPendencies(idLab, startDate, endDate, undefined, typeOfSearch, q),
        pendenciesService.obtainQuantityPendencies(idLab, startDate, endDate, ['P'], typeOfSearch, q),
        pendenciesService.obtainQuantityPendencies(idLab, startDate, endDate, ['R'], typeOfSearch, q)
      ])

      commit(PENDENCIES_TOTAL_QUANTITY, todos.data)
      commit(PENDENCIES_SET_TOTAL_PENDENTE, pendente.data)
      commit(PENDENCIES_SET_TOTAL_REALIZADO, realizado.data)
      commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_SUCCESS')
    } catch (e) {
      commit(PENDENCIES_TOTAL_QUANTITY, 0)
      commit(PENDENCIES_SET_TOTAL_PENDENTE, 0)
      commit(PENDENCIES_SET_TOTAL_REALIZADO, 0)
      commit(PENDENCIES_TOTAL_SET_LOADING_STATUS, 'STATUS_FAILED')
    }
  },
  setCurrentTabPendencies({ commit }, index) {
    commit(PENDENCIES_SET_CURRENT_TAB, index)
    commit('PENDENCIES_INCREASE_FORCE_UPDATED_INFINITE_LOADING')
  },
  resetStore({ commit }) {
    commit('RESET_STORE')
  }
}

let createFileNewTabLink = function ({ file, fileName, fileExtension }) {
  let blob = new Blob([file.data], { type: 'application/' + fileExtension })
  let download = document.createElement('a')
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    download.href = window.URL.createObjectURL(blob)
    download.target = '_blank'
    download.download = fileName
  }
  if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'gif') {
    var image = new Image()
    image.src = URL.createObjectURL(blob)
    var w = window.open('')
    w.document.write(image.outerHTML)
  } else if (fileExtension === 'pdf') {
    var url = window.URL.createObjectURL(blob, { oneTimeOnly: true })
    var anchor = document.createElement('a')
    anchor.href = url
    anchor.target = '_blank'
    anchor.click()
  } else {
    document.body.appendChild(download)
    download.style.visibility = 'hidden'
    download.click()
    return download
  }
}

let builderStatusAndStates = filterBy => {
  let status = []

  if (filterBy) {
    if (Array.isArray(filterBy)) {
      filterBy.forEach(selected => {
        status.push(selected)
      })
    } else {
      status.push(filterBy)
    }
  }

  return status
}

let submitAnalyticsEventAction = function (value) {
  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'Gestao de Pendencias',
      action: value,
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName
    })
  }
}

let submitAnalyticsEventTotal = function (value) {
  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'Gestao de Pendencias',
      action: 'Quantidade de pendências',
      label: value,
      value: value,
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName
    })
  }
}

let analyticsForUploadTime = ({ startTime, fileSize, response }) => {
  let endTime = Moment(new Date())
  let uploadTime = endTime.diff(startTime, 'seconds')

  let profile = getCookie('profile') || null
  if (profile) {
    analytics.pushAnalyticsEvent('ga-event', {
      category: 'Gestao de Pendencias',
      action: 'Tempo de Upload - ' + response,
      label: uploadTime,
      value: uploadTime,
      'id-user': profile.id,
      'id-lab': profile.id_laboratory,
      'name-lab': profile.laboratoryName,
      'file-size': fileSize
    })
  }
}

let analyticsPendenciesIdPerLab = pendencies => {
  let profile = getCookie('profile') || null
  if (profile) {
    for (const pendency of pendencies) {
      analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gestao de Pendencias',
        action: 'Pendencia id',
        'id-user': profile.id,
        'id-lab': profile.id_laboratory,
        'name-lab': profile.laboratoryName,
        'pendency-id': pendency.id,
        'pendency-status': pendency.status,
        'created-at': pendency.createdAt
      })
    }
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
